/* eslint-disable react-hooks/exhaustive-deps */
import useApiClient from "../hooks/useApiClient";
import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";

const PlatformContext = createContext({
    platform: null,
    setPlatform: () => {},
});

const PlatformProvider = ({ children }) => {
    const [platform, setPlatform] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const { api, urls } = useApiClient();

    useEffect(() => {
        if (isLoading) {
            (async () => {
                try {
                    // Fetch User
                    const user = await api.get(urls.user);
                    localStorage.setItem(
                        "user-session",
                        JSON.stringify(user?.data)
                    );
                    // Fetch Platform
                    const res = await api.get(urls.platform, {
                        params: {
                            language: "en",
                        },
                    });
                    localStorage.setItem("platform", JSON.stringify(res.data));
                    setPlatform(res.data);
                    setIsLoading(false);
                } catch (error) {
                    if (error.code === "ERR_NETWORK") {
                        toast.error("Network error. Please try again later.");
                    }
                    console.error("Error fetching platform:", error);
                    setIsLoading(false);
                }
            })();
        }
    }, [isLoading]);

    return (
        <PlatformContext.Provider value={{ platform, setPlatform }}>
            {children}
        </PlatformContext.Provider>
    );
};

export const usePlatform = () => {
    const { platform, setPlatform } = useContext(PlatformContext);
    return { platform, setPlatform };
};

export default PlatformProvider;
